import { performRequest } from "../performRequest"



export const getAllAssetsApi = (params) => {
    return performRequest("get", "api/ess/asset-master/",params)
}

export const getAssetDetailApi = (id, params) => {
    return performRequest("get", `api/ess/asset-master/${id}/`,params)
}


export const returnAssetApi = (id, params) => {
    
    return performRequest("patch", `api/ess/asset/${id}/return/`,params)    
}


export const updateAssetApi = (id, params) => {
    const company = localStorage.getItem('company') || 1

    params.company = company

    return performRequest("patch", `api/ess/asset-master/${id}/`,params)    
}

export const createAssetMasterApi = ( params) => {
    const company = localStorage.getItem('company') || 1

    params.company = company

    return performRequest("post", `api/ess/asset-master/`,params)    
}

export const getAssetCategory = ( params) => {
    return performRequest("get", `api/ess/asset-category/`,params)    
}




export const createAssetUser= ( params) => {
    return performRequest("post", `api/ess/asset/user/`,params)    
}



export const updateAssetUser= ( id, params) => {
    return performRequest("put", `api/ess/asset/user/${id}/`,params)    
}




export const getAssetUserDetailApi = (id, params) => {
    return performRequest("get", `api/ess/asset/${id}/`,params)
}


export const statusChangeAssetApi = (id, params) => {
    return performRequest("patch", `/api/ess/asset/${id}/return/`,params)
}